export default __webpack_public_path__ + "static/media/Icons_Minus.4744803d.svg";